module.exports = __webpack_public_path__ + "img/avatar6.512a17be.png";